module.exports = __webpack_public_path__ + "img/catG.35f473ff.svg";